import { logout, SsoLogoutResponse } from 'lib/auth';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from './alert-context';

export default function useLogout(goToHomepage: boolean = false) {
  const { t } = useTranslation();
  const showAlert = useAlert();
  const [loading, setLoading] = useState(false);

  const doLogout = async () => {
    setLoading(true);
    try {
      const res = await logout();
      if (goToHomepage) {
        window.location.replace('/');
      }
      // If we need to logout on sso provider too, redirect there
      if (res != null) {
        window.location.assign(createSsoLogoutUrl(res));
      } else {
        // Do hard reload to wipe everything
        window.location.reload(true);
      }
    } catch (e) {
      console.error('Logout failed', e);
      showAlert({
        title: t('logoutButton.logoutFailed.title', 'Odhlášení selhalo'),
        body: t(
          'logoutButton.logoutFailed.body',
          'Chyba serveru: {{message}}\nMůžete zkusit smazat cookies ručně v nastavení prohlížeče',
          { message: e.message },
        ),
      });
    } finally {
      setLoading(false);
    }
  };
  return { loading, logout: doLogout };
}

const createSsoLogoutUrl = (res: SsoLogoutResponse) => {
  const { location } = window;
  const redirectUri = `${location.origin}/logout`;
  const params = new URLSearchParams({
    post_logout_redirect_uri: redirectUri,
  });
  if (res.idToken) {
    params.set('id_token_hint', res.idToken);
  }
  return `${res.endSsoSessionEndpoint}?${params.toString()}`;
};
